import { Box, Button, ButtonProps } from "@mui/material";
import * as React from "react";
import {
  getCurrentSizeProfile,
  TypoSize,
  responsiveFontSize,
} from "../Typography/style";

export interface IconButtonProps {
  size?: TypoSize;
}
type UnionType = Omit<ButtonProps, "size"> & IconButtonProps;

const IconButton = (props: React.PropsWithChildren<UnionType>) => {
  const { size = "small", ...other } = props;

  return (
    <Box
      sx={(theme) => ({
        "& .MuiButton-root": {
          borderRadius: "50%",
          fontSize: getCurrentSizeProfile()[size],
          ...responsiveFontSize(theme, size),
          minWidth: "3em",
          minHeight: "3em",
          width: "3em",
          height: "3em",
          borderWidth: "2px",
        },
      })}
    >
      <Button {...other}>{props.children}</Button>
    </Box>
  );
};

export default IconButton;
